import React from "react"
import PropTypes from "prop-types"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"
import { metadataSelector } from "store/selectors"
import StatCard from "./StatCard"
import { getDateLabel } from "./utils/dateLabels"

TotalBookingValue.propTypes = {
  params: PropTypes.shape({
    overview_range: PropTypes.string.isRequired,
    date_gteq: PropTypes.string,
    date_lteq: PropTypes.string
  }).isRequired
}

export default function TotalBookingValue({ params }) {
  const { t } = useTranslation()
  const { bookings_stats } = useSelector(metadataSelector("accounting"))
  const dates = getDateLabel(params)

  const tooltip = (
    <>
      {t("accounting.labels.total_booking_value_tooltip_new", { clients: bookings_stats?.new_clients || 0 })}
      <br />
      {t("accounting.labels.total_booking_value_tooltip_recurring", { recurringClients: bookings_stats?.recurring_clients || 0 })}
    </>
  )

  return (
    <StatCard
      title={t("accounting.labels.total_booking")}
      tooltip={tooltip}
      dates={dates}
      value={bookings_stats[params.overview_range]}
      monthlyDiff={bookings_stats.monthly_diff}
      isCurrentMonth={params.overview_range === "current_month"}
    />
  )
}
